import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/fonts/BerninaSans-Web-Extrabold.woff';
import './assets/fonts/BerninaSans-Web-Light.woff';
import './assets/fonts/BerninaSans-Web-Regular.woff';
import './assets/fonts/BerninaSans-Web-Semibold.woff';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
